var cov_6zbv4lh03 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Breadcrumb/index.tsx",
      hash = "d689f455a87bc9489cf86414f4c94619484cd9b4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Breadcrumb/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 33
        }
      },
      "2": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "3": {
        start: {
          line: 29,
          column: 12
        },
        end: {
          line: 31,
          column: 18
        }
      },
      "4": {
        start: {
          line: 39,
          column: 27
        },
        end: {
          line: 39,
          column: 37
        }
      },
      "5": {
        start: {
          line: 40,
          column: 14
        },
        end: {
          line: 40,
          column: 40
        }
      },
      "6": {
        start: {
          line: 41,
          column: 15
        },
        end: {
          line: 41,
          column: 22
        }
      },
      "7": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "8": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "9": {
        start: {
          line: 44,
          column: 69
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "10": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 37
        }
      },
      "11": {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 47,
          column: 37
        }
      },
      "12": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      "13": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 62,
          column: 9
        }
      },
      "14": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 51
        }
      },
      "15": {
        start: {
          line: 69,
          column: 40
        },
        end: {
          line: 69,
          column: 50
        }
      },
      "16": {
        start: {
          line: 70,
          column: 22
        },
        end: {
          line: 70,
          column: 76
        }
      },
      "17": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "18": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 79,
          column: 19
        }
      },
      "19": {
        start: {
          line: 86,
          column: 0
        },
        end: {
          line: 86,
          column: 45
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 42
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 41
          },
          end: {
            line: 28,
            column: 42
          }
        },
        loc: {
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 31,
            column: 18
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 29
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 11
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 68
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 75,
            column: 19
          },
          end: {
            line: 75,
            column: 20
          }
        },
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 79,
            column: 19
          }
        },
        line: 76
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 43,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 43,
            column: 19
          }
        }, {
          start: {
            line: 43,
            column: 23
          },
          end: {
            line: 43,
            column: 28
          }
        }],
        line: 43
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 37
          }
        }, {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 37
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 11
          },
          end: {
            line: 65,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 24
          },
          end: {
            line: 65,
            column: 44
          }
        }, {
          start: {
            line: 65,
            column: 47
          },
          end: {
            line: 65,
            column: 51
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 9
          },
          end: {
            line: 80,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 9
          },
          end: {
            line: 74,
            column: 13
          }
        }, {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 80,
            column: 12
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 76,
            column: 23
          },
          end: {
            line: 76,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 32
          },
          end: {
            line: 76,
            column: 56
          }
        }, {
          start: {
            line: 76,
            column: 59
          },
          end: {
            line: 76,
            column: 64
          }
        }],
        line: 76
      },
      "7": {
        loc: {
          start: {
            line: 77,
            column: 15
          },
          end: {
            line: 77,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 34
          },
          end: {
            line: 77,
            column: 53
          }
        }, {
          start: {
            line: 77,
            column: 56
          },
          end: {
            line: 77,
            column: 74
          }
        }],
        line: 77
      },
      "8": {
        loc: {
          start: {
            line: 78,
            column: 15
          },
          end: {
            line: 78,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 78,
            column: 43
          },
          end: {
            line: 78,
            column: 108
          }
        }, {
          start: {
            line: 78,
            column: 111
          },
          end: {
            line: 78,
            column: 115
          }
        }],
        line: 78
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Breadcrumb/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Popover from '../Popover';
import { defaultProps } from '../utils/defaultProps';
import { breadcrumbClass } from './styles';
import { getKey } from '../utils/uid';
import Caret from '../icons/Caret';
var defaultValue = (cov_6zbv4lh03.s[0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  data: [],
  separator: '/'
}));

var Breadcrumb =
/*#__PURE__*/
function (_ref) {
  _inherits(Breadcrumb, _ref);

  var _super = _createSuper2(Breadcrumb);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumb, [{
    key: "renderArray",
    value: function renderArray(data) {
      var _this = this;

      cov_6zbv4lh03.f[0]++;
      var first = (cov_6zbv4lh03.s[1]++, data[0]);
      cov_6zbv4lh03.s[2]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 7
          }
        }, this.renderItem(first),
        /*#__PURE__*/
        React.createElement("span", {
          className: breadcrumbClass('down'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Caret, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26,
            columnNumber: 52
          }
        })),
        /*#__PURE__*/
        React.createElement(Popover, {
          position: "bottom",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27,
            columnNumber: 9
          }
        }, data.slice(1).map(function (d, i) {
          cov_6zbv4lh03.f[1]++;
          cov_6zbv4lh03.s[3]++;
          return (
            /*#__PURE__*/
            React.createElement("div", {
              className: breadcrumbClass('dropdown-item'),
              key: i,
              __self: _this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 29,
                columnNumber: 13
              }
            }, _this.renderItem(d))
          );
        })))
      );
    }
  }, {
    key: "renderItem",
    value: function renderItem(dataItem) {
      cov_6zbv4lh03.f[2]++;

      var _ref2 = (cov_6zbv4lh03.s[4]++, this.props),
          renderItem = _ref2.renderItem;

      var d = (cov_6zbv4lh03.s[5]++, dataItem);
      var item = (cov_6zbv4lh03.s[6]++, d.title);
      cov_6zbv4lh03.s[7]++;

      if (!
      /*#__PURE__*/
      React.isValidElement(item)) {
        cov_6zbv4lh03.b[0][0]++;
        cov_6zbv4lh03.s[8]++;

        if ((cov_6zbv4lh03.b[2][0]++, d.onClick) || (cov_6zbv4lh03.b[2][1]++, d.url)) {
          cov_6zbv4lh03.b[1][0]++;
          var props = (cov_6zbv4lh03.s[9]++, {
            onClick: d.onClick
          });
          cov_6zbv4lh03.s[10]++;

          if (d.url) {
            cov_6zbv4lh03.b[3][0]++;
            cov_6zbv4lh03.s[11]++;
            props.href = d.url;
          } else {
            cov_6zbv4lh03.b[3][1]++;
          }

          cov_6zbv4lh03.s[12]++;
          item =
          /*#__PURE__*/
          React.createElement("a", Object.assign({}, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 49,
              columnNumber: 11
            }
          }), d.icon, "\xA0", d.title);
        } else {
          cov_6zbv4lh03.b[1][1]++;
          cov_6zbv4lh03.s[13]++;
          item =
          /*#__PURE__*/
          React.createElement("b", {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 57,
              columnNumber: 11
            }
          }, d.icon, "\xA0", d.title);
        }
      } else {
        cov_6zbv4lh03.b[0][1]++;
      }

      cov_6zbv4lh03.s[14]++;
      return renderItem ? (cov_6zbv4lh03.b[4][0]++, renderItem(dataItem)) : (cov_6zbv4lh03.b[4][1]++, item);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_6zbv4lh03.f[3]++;

      var _ref3 = (cov_6zbv4lh03.s[15]++, this.props),
          data = _ref3.data,
          separator = _ref3.separator,
          keygen = _ref3.keygen;

      var className = (cov_6zbv4lh03.s[16]++, classnames(breadcrumbClass('_'), this.props.className));
      cov_6zbv4lh03.s[17]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: this.props.style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73,
            columnNumber: 7
          }
        }, (cov_6zbv4lh03.b[5][0]++, data) && (cov_6zbv4lh03.b[5][1]++, data.map(function (d, index) {
          cov_6zbv4lh03.f[4]++;
          cov_6zbv4lh03.s[18]++;
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: keygen ? (cov_6zbv4lh03.b[6][0]++, getKey(d, keygen, index)) : (cov_6zbv4lh03.b[6][1]++, index),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 76,
                columnNumber: 13
              }
            }, Array.isArray(d) ? (cov_6zbv4lh03.b[7][0]++, _this2.renderArray(d)) : (cov_6zbv4lh03.b[7][1]++, _this2.renderItem(d)), index !== data.length - 1 ? (cov_6zbv4lh03.b[8][0]++,
            /*#__PURE__*/
            React.createElement("span", {
              className: breadcrumbClass('separator'),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 78,
                columnNumber: 44
              }
            }, separator)) : (cov_6zbv4lh03.b[8][1]++, null))
          );
        })))
      );
    }
  }]);

  return Breadcrumb;
}((React.PureComponent));

Breadcrumb.defaultProps = defaultValue;
Breadcrumb.displayName = void 0;
cov_6zbv4lh03.s[19]++;
Breadcrumb.displayName = 'ShineoutBreadcrumb';
export default Breadcrumb;